import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'g10-transport-manager-account-profile',
  templateUrl: './transport-manager-account-profile.component.html',
  styleUrls: ['./transport-manager-account-profile.component.css']
})
export class TransportManagerAccountProfileComponent implements OnInit {

  userInfo: any;
  public defaultImage = '../../../../../assets/images/profile/account.png';
  public userImage: any;
  public updatedImage: any;
  public enableProfileCard: boolean = false;
  public closePopup = true;
  userType: string;
  // public logoImage;

  public profile: File | string = ''; // To store the selected file
  public profileImage: string | null = null;
  public profileFileName: string;


  public user;

  public logoImage: File | string = ''; // To store the selected file
  public imagePreview: string | null = null;
  public logoFileName: string;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('fileInputProfile') fileInputProfile: ElementRef;
  constructor(
    public storage: StorageService,
    public api: ApiService,
    public swal: SweetAlert,
    public router: Router,
    public file: FileUploadService,
    public loader: LoaderService
  ) {

    this.userType = this.storage.get('userType');

  }

  ngOnInit(): void {
    if (this.userType != 'admin') {

    }
    this.getUserData();
  }


  getUserData() {
    this.api.GetCurUserOrg({}).then((res: any) => {
      if (res.status == 'success') {
        this.userInfo = res.data[0];
        this.storage.setData({ userInfo: this.userInfo });
        this.enableProfileCard = true;
        this.imagePreview = undefined;
        let image = this.userInfo['logo'] ?? '';
        this.imagePreview = image + '?ts=' + Date.now();
        this.logoFileName = this.userInfo['logoName'] ?? '';
        let profilImage = this.userInfo['profilePic'];
        this.profileImage = profilImage + '?ts=' + Date.now();

        // this.imagePreview = this.userInfo['logo'] ? this.userInfo['logo'] : '';
        // this.logoFileName = this.userInfo['logoName'] ? this.userInfo['logoName'] :''


        // this.profileImage = this.userInfo['profilePic'];
        // fetch(this.userInfo['profilePic'])
        // .then(response => {
        //     console.log(response.statusText);
        //     return response.text();
        // })
        // .then(data =>{
        //   if(data){ 
        //   this.profileImage=data;
        //   }
        // } ); // got data
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }
  enableChangeMobile() {
    this.closePopup = false;
  }

  clkFun(field) {
    // this.getUserData.controls[logo].patchValue('');
    if (field == 'profilePic') {
      this.profileImage = '';
    }
    else if (field == 'logoUpload') {
      this.logoImage = '';
    }
  }
  reUpload(field) {
    document.getElementById(field).click();
  }

  async imageUpload(event, type) {
    const file = (event.target as HTMLInputElement).files?.[0]
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (!file) return;
    const isValid = this.validateFile(file, allowedImageTypes, maxFileSize);
    if (!isValid) return;

    this.setImageValue(file, type)
    this.imageBase64(file, type)

    var imgDest: any = document.getElementById('img-dest')
    if (imgDest && type == 'logo') {
      imgDest.style.marginTop = '0px';
    }
  }

  validateFile(file, allowedImageTypes, maxFileSize) {
    if (!allowedImageTypes.includes(file.type)) {
      return this.showErrorMessage('Invalid file type. Only images are allowed.');
    }
    if (file.size > maxFileSize) {
      return this.showErrorMessage(`File size exceeds 1 MB`);
    }
    return true;
  }

  imageBase64(file, type) {
    const reader = new FileReader();
    reader.onload = () => {
      // type == 'logo' ? this.imagePreview = reader.result as string : this.profileImage = reader.result as string;
      const key = type === 'logo' ? 'imagePreview' : 'profileImage';
      (this as any)[key] = reader.result as string;
    }
    reader.readAsDataURL(file)
  }

  async setImageValue(file, type) {
    let obj: Record<string, any> = {}

    if (type == 'logo') {
      this.logoImage = file;
      this.logoFileName = file.name;
      obj['logo'] = this.logoImage;
      obj['logoFileType'] = 'Image';
    } else {
      this.profile = file;
      this.profileFileName = file.name;
      obj['profile'] = this.profile;
      obj['profileType'] = 'Image';
    }

    try {
      await this.updateProfileImages(obj)
    } catch (err) {
      console.log("error in updateProfileImages", err)
    } finally {
      this.imagePreview = '';
      this.logoFileName = '';
      this.profileImage = '';
      this.profileFileName = '';
    }
  }

  // async profileUpload(event, elemId) {
  //   this.profileImage = await this.file.fileHandeleBase64(event);

  //   this.updateProfileData();
  //   var imgDest: any = document.getElementById(elemId)
  //   imgDest.style.backgroundImage = `url(${this.profileImage})`
  //   const file = event.srcElement.files[0];
  //   imgDest.src = this.profileImage;

  // }

  updateImage() {
    document.getElementById('profile').click();
  }
  updateProfileData() {
    let obj = {
      // logo: this.logoImage,
      profile: this.profileImage
    }
    this.api.updateCurUserOrg(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        setTimeout(() => {
          this.enableProfileCard = false;
          this.getUserData()
        }, 2500)
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }

  updateProfileImages(obj) {
    let url = 'organization/organization/userUpdateProfileLogo';
    this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
      if (res['responseJSON']['status'] == 'success') {
        this.loader.hide();
        this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
        this.enableProfileCard = false;
        this.getUserData()
      }
      if (res['responseJSON'].status == 'failure') {
        this.loader.hide();
        this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
      }
    })
  }

  updateUserData() {
    let obj = {
      logo: this.logoImage,
      // profile:this.profileImage
    }
    this.api.updateCurUserOrg(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        setTimeout(() => {
          this.enableProfileCard = false;
          this.getUserData()
        }, 2500)
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }

  openFile(type) {
    if (type == 'logo') {
      this.fileInput.nativeElement.click()
    }
    if (type == 'profile') {
      this.fileInputProfile.nativeElement.click()
    }
  }

  private showErrorMessage(message: string) {
    this.swal.swalFunction('error', 'error', message, 5000);
  }
}



